import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    city:'',//当前城市
    latitude: '', // 当前位置纬度
    longitude: '', // 当前位置经度
    userInfo: null, //用户信息
    hotelId: null,//酒店id
    remarkText: null,//可选备注内容
    invoice: false,//开发票
    address: null,//选择地址
    login: true,//是否登录
    imgPath:null,//头像地址
}

export default new Vuex.Store({
    state
})


// WEBPACK FOOTER //
// ./src/assets/js/store.js